import type {
  Lfa_Conversion_Data_Rejection_Criteria,
  Lfa_Service_Rejection_Criteria_Input,
} from '~/graphql/types';
import hasValue from '~/util/hasValue';
import type { ValidationField } from '../../../../state/validationState';

const text = {
  selectReason: 'Selecteer minimaal één reden voor afwijzing',
  enterReason: 'Voer een reden in voor afwijzing',
};

const validateCriteria = (
  rejectionCriteria:
    | Array<Lfa_Conversion_Data_Rejection_Criteria>
    | Array<Lfa_Service_Rejection_Criteria_Input>,
): { field: ValidationField; message: string } | null => {
  if (rejectionCriteria.length === 0) {
    return {
      field: 'criteria',
      message: text.selectReason,
    };
  }
  const customReason = rejectionCriteria.find(
    criteria => criteria.id === 'custom_reason',
  );

  if (customReason && !hasValue(customReason.reason)) {
    return {
      field: 'customReason',
      message: text.enterReason,
    };
  }

  return null;
};

export default validateCriteria;
